/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useParams } from 'react-router'

import { Growl } from 'primereact/growl'

import ManageCompanyComponent from '../components/ManageCompanyComponent'
import { companyActions, lookupActions } from '../_actions'
import { messageConstants } from '../_constants'
import { titleCase, getLoader } from '../_common/utils'

function ManageCompanyContainer({ masterList, lookupData, companyList, getCompanyByPage, totalRecords,
  bulkAdd, bulkUpdate, deleteCompany, activeCompany, isLookupLoadedAll,
  deletedData, activeData, isCompanyLoading, clearAllMessages,
  bulkUpdateSuccessMessage, bulkUpdatesubBrand, currentPage, getCompany, bulkUpdateResponse }) {
  const { type, typeId } = useParams()

  useEffect(() => {
    if (activeData && activeData.message) {
      showActiveCompanyGrowl(activeData.message)
      clearAllMessages()
    }
    if (deletedData && deletedData.message && deletedData.message === 'success') {
      showShowDeleteGrowl()
      clearAllMessages()
    }
    if (bulkUpdateSuccessMessage && bulkUpdateSuccessMessage === 'success' && bulkUpdateResponse) {
      if (bulkUpdateResponse['updated']?.length > 0) {
        growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: titleCase('Updated ') + ' ' + messageConstants.activeCompany.success })
        clearAllMessages()
      }
    }

  }, [masterList, companyList, isLookupLoadedAll, activeData, deletedData])
  useEffect(() => {
    if (!bulkUpdateResponse)
      lookupData('force')
  }, [companyList])

  const growl = useRef()
  const showActiveCompanyGrowl = (message) => {
    growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: titleCase(message) + ' ' + messageConstants.activeCompany.success })
    getCompanyByPage(currentPage ? currentPage : 0, 20, '', type, typeId, '')
  }
  const showShowDeleteGrowl = () => {
    growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: messageConstants.deleteCompany.success })
    getCompanyByPage(currentPage ? currentPage : 0, 20, '', type, typeId, '')
  }
  const showGrowlMessage = (message) => {
    growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: message })
  }

  return (
    <div className="p-grid pageWrapper">
      {isCompanyLoading ? getLoader() : ''}
      <Growl ref={growl} />
      <ManageCompanyComponent
        companyList={companyList}
        getCompanyByPage={getCompanyByPage}
        totalRecords={totalRecords}
        bulkAdd={bulkAdd}
        bulkUpdate={bulkUpdate}
        masterList={masterList}
        deleteCompany={deleteCompany}
        activeCompany={activeCompany}
        type={type}
        typeId={typeId}
        bulkUpdateSuccessMessage={bulkUpdateSuccessMessage}
        showGrowlMessage={showGrowlMessage}
        bulkUpdatesubBrand={bulkUpdatesubBrand}
        clearAllMessages={clearAllMessages}
        currentPage={currentPage}
        getCompany={getCompany}
        isCompanyLoading={isCompanyLoading}
        bulkUpdateResponse={bulkUpdateResponse}
      />
    </div>
  )
}

ManageCompanyContainer.propTypes = {
  companyList: PropTypes.array,
  getCompanyByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  bulkAdd: PropTypes.func,
  bulkUpdate: PropTypes.func,
  bulkUpdatesubBrand: PropTypes.func,
  masterList: PropTypes.object,
  lookupData: PropTypes.func,
  isGetAllError: PropTypes.bool,
  deletedData: PropTypes.object,
  activeData: PropTypes.object,
  activeCompany: PropTypes.func,
  deleteCompany: PropTypes.func,
  isLookupLoadedAll: PropTypes.bool,
  isCompanyLoading: PropTypes.bool,
  type: PropTypes.string,
  typeId: PropTypes.string,
  clearAllMessages: PropTypes.func,
  bulkUpdateSuccessMessage: PropTypes.string,
  isPageLoad: PropTypes.bool,
  currentPage: PropTypes.number,
  getCompany: PropTypes.func,
  bulkUpdateResponse: PropTypes.object
}
const mapStateToProps = state => {
  return {
    masterList: state.lookup,
    isCompanyLoading: state.company.isLoading,
    companyList: state.company.companyList ? state.company.companyList : [],
    totalRecords: state.company.count,
    isGetAllError: state.company.isGetAllError,
    deletedData: state.company.deletedData ? state.company.deletedData : {},
    activeData: state.company.activeData ? state.company.activeData : {},
    isLookupLoadedAll: state.lookup.isLoadedAll,
    bulkUpdateSuccessMessage: state.company.bulkUpdateSuccessMessage,
    isPageLoad: state.company.isPageLoad,
    currentPage: state.company.currentPage,
    bulkUpdateResponse: state.company.bulkUpdatResponse
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    lookupData: (force) => dispatch(lookupActions.lookupData(force)),
    getCompanyByPage: (start, pageSize, search, type, typeid, sortBy) => dispatch(companyActions.getCompanyByPage(start, pageSize, search, type, typeid, sortBy)),
    bulkAdd: (companyList) => dispatch(companyActions.bulkAdd(companyList)),
    bulkUpdate: (companyList) => dispatch(companyActions.bulkUpdate(companyList)),
    bulkUpdatesubBrand: (companyList) => dispatch(companyActions.bulkUpdatesubBrand(companyList)),
    deleteCompany: (id, userId) => dispatch(companyActions.deleteCompany(id, userId)),
    activeCompany: (id, isActive, currentPage) => dispatch(companyActions.activeCompany(id, isActive, currentPage)),
    clearAllMessages: () => dispatch(companyActions.clearAllMessages()),
    getCompany: () => dispatch(companyActions.getCompany())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageCompanyContainer)
